




















import Vue from "vue";

export default Vue.extend({
  name: "NotificationError",
  methods: {
    handleReload(): void {
      this.$router.go(0);
    }
  }
});
